import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhToasterMessagesComponent } from './components/fh-toaster-messages/fh-toaster-messages.component';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, ToastModule, ButtonModule, RippleModule, TranslateModule],
  declarations: [FhToasterMessagesComponent],
  exports: [FhToasterMessagesComponent]
})
export class FhToasterMessagesModule {}
